import { FilterBlogsDto } from './models/blogs/requests/filter-blogs-dto';
import { ApiService } from './api-service';
import { inject } from 'aurelia';
import { websiteShortCode } from '../environment';

@inject(ApiService)
export class BlogService {
    path = 'BlogPost';
    blogs;
    blogsCount;

    constructor(private api: ApiService) {}

    async getPublishedBlogPosts(recordQuantity: number, page: number) {
        return await this.api.doGet(`${this.path}/byWebsite/${recordQuantity}/${page}?websiteShortCode=${websiteShortCode()}`);
    }

    async getPublishedBlogPostsCount() {
        if (!this.blogsCount) {
            this.blogsCount = await this.api.doGet(this.path + `/BlogsCountByWebsite?websiteShortCode=${websiteShortCode()}`);
        }
        return this.blogsCount;
    }

    async getById(id) {
        return await this.api.doGet(this.path + '/' + id);
    }

    async getBlogBySlug(slug) {
        return await this.api.doGet(`${this.path}/GetBySlug/${slug}?websiteShortCode=${websiteShortCode()}`);
    }

    async updateBlogPostViewCounter(id) {
        return await this.api.doPut(this.path + `/${id}/AddViewsCounter`, {});
    }

    async getStickyBlogPost() {
        return await this.api.doGet(`${this.path}/StickyPost?websiteShortCode=${websiteShortCode()}`);
    }

    async getByTag(tag, page, pageSize) {
        return await this.api.doGet(`${this.path}/GetByTag/${tag}/${pageSize}/${page}`);
    }

    async getBySearchByContent(expression, pageSize, page) {
        return await this.api.doGet(`${this.path}/SearchByContent/${expression}/${pageSize}/${page}`);
    }

    async filterBlogs(filterBlogsDto: FilterBlogsDto) {
        return await this.api.doPost(`${this.path}/DynamicFilter`, filterBlogsDto);
    }
}
